import { DatagridColumn } from "../utils/types";
import { DatagridHelper } from "./DatagridHelper";

function SummaryRow(props: any) {
  const tds : any[] = [];
  for (let index = 0; index < props.filteredColumns.length; index++) {
    const item = props.filteredColumns[index] as DatagridColumn;

    if (item.visible === true) {
      const value = props.rowData[item.id];

      const formattedValue = DatagridHelper.formatValue(item.type, value, item.precision);
      const tooltipFormattedValue = DatagridHelper.formatValue(item.type, value, item.precision, true);

      const key = "" + (2000 + index);

      tds.push(<td key={key} align={item.align} title={tooltipFormattedValue} ><b>{formattedValue}</b></td>);
    }
  }

  return (
    <tr key={"trSummary"} className="table-primary" style={{ background: "white" }}>
      {tds} 
    </tr>
  );
}

export default SummaryRow;